(() => {
    const $newsletterSuccess = document.querySelector('.site-footer__newsletter-success');
    const $newsletterForm = document.querySelector('.site-footer__newsletter-form');
    const $newsletterUrlInput = document.getElementById("ci_consenturl");
    const $newsletterSubmitButton = document.getElementById('btnsubmit-06b298b');

    const initNewsletterForm = () => {
        if (!$newsletterForm) return;

        if ($newsletterUrlInput != null && $newsletterUrlInput != 'undefined') {
            $newsletterUrlInput.value = encodeURI(window.location.href);
        }

        const pristine = new Pristine($newsletterForm);

        $newsletterForm.addEventListener('submit', e => {
            e.preventDefault();
    
            if (!pristine.validate()) return;
    
            const formData = new FormData($newsletterForm);
            formData.append($newsletterSubmitButton.name, $newsletterSubmitButton.value);
            
            fetch('https://r1.twocircles-client.com/signup.ashx', {
                method: 'POST',
                body: formData,
                headers: {
                    'No-Redirect': 1
                }
            }).then((response) => {
                if (response.status !== 202) {
                    alert('There was an error submitting the form.');
                    return;
                }
                
                $newsletterForm.classList.add('site-footer__newsletter-form--hide');
                $newsletterSuccess.classList.add('site-footer__newsletter-success--show');
            }).catch((error) => {
                console.error('Error:', error);
                alert('There was an error submitting the form.');
            });
        });
    }

    initNewsletterForm();
})();
